"use client";

import {
  formatDate,
  formatMonthDay,
  formatRelative,
  formatTime,
} from "@/utils/date";
import { useEffect, useState } from "react";

type DateFormat = "date" | "time" | "month-day" | "relative";

type FormatDateProps = {
  format?: DateFormat;
  date: string;
};

const getDateFormatter = (format?: DateFormat) => {
  if (format === "time") {
    return formatTime;
  }

  if (format === "month-day") {
    return formatMonthDay;
  }

  if (format === "relative") {
    return formatRelative;
  }

  return formatDate;
};

const FormatDate = (props: FormatDateProps) => {
  const [isServer, setIsServer] = useState(true);

  useEffect(() => {
    setIsServer(false);
  }, []);

  const dateFormatter = getDateFormatter(props.format);

  return (
    <span>
      {isServer
        ? dateFormatter(props.date, "sv-SE", "Europe/Stockholm")
        : dateFormatter(props.date, "sv-SE", "Europe/Stockholm")}
    </span>
  );
};

export default FormatDate;
